import { IconType } from "react-icons";
import { Dissemination } from "./interfaces";

export enum SelectedPage {
  Home = "home",
  About = "about",
  Competences = "competences",
  Projects = "projects",
  News = "news",
  Contacts = "contacts",
  Privacy = "privacy",
}

export enum Screens {
  Huge = "(min-width: 2550px) and (min-height: 1430)",
  Large = "(min-width: 2210px) and (min-height: 1070px)",
  Medium = "(min-width: 1366px) and (min-height: 768px)",
  Small = "(min-width: 900px) and  (min-height: 640px)",
}

export enum Color {
  palette1 = "#0F0F0F",
  palette2 = "#293896",
  palette3 = "#4F86C6",
  palette4 = "#F3F4F6",
  palette5 = "#ffffff",
}
/*
export enum Color {
  palette1 = "#191308",
  palette2 = "#293896",
  palette3 = "#4F86C6",
  palette4 = "#DAE3E5",
  palette5 = "#fffffa",
}*/

export interface DisseminationItem {
  text: string;
  urls: CompetenceUrl[];
}


export interface NewsItem {
  title: string;
  date: string;
  content: string;
  link?: string; // Opzionale: URL per ulteriori dettagli sulla notizia
  images: string[]; // Array di URL delle immagini relative alla notizia
  shortContent: string;
  dissemination?: DisseminationItem;
}

export interface CompetenceUrl {
  name: string;
  url: string;
}

export interface SubSubSubCompetence {
  id: number;
  title: string;
  shortDescription: string;
  image: string;
  longDescription: string;
  urls?: CompetenceUrl[];
}

export interface SubCompetence {
  id: number;
  title: string;
  shortDescription: string;
  image: string;
  longDescription: string;
  items: SubSubCompetence[];
}

export interface SubSubCompetence {
  id: number;
  title: string;
  shortDescription: string;
  image: string;
  longDescription: string;
  items: SubSubSubCompetence[];
}

export interface Competence {
  id: number;
  title: string;
  color: string;
  shortDescription: string;
  icon: JSX.Element; // Assumendo che "image" sia una stringa che rappresenta l'URL dell'immagine
  longDescription: string;
  items: SubCompetence[];
}
